import { ca } from '@cian/analytics';

import { adAnalyticsCategory } from '../../scripts/services/analytics.service';

export const trackSelectIdentification = (type) => {
  ca('event', {
    name: 'oldevent',
    category: type,
    action: 'Start',
    label: adAnalyticsCategory,
  });
};
